import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

export class ToastNotification {
  constructor(public title: string, public message: string, public toastClasses?: string, public eventId?: string, public isReportButtonShown?: boolean) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationsService {

  toDisplay = new Subject<ToastNotification>();

  display(notification: ToastNotification) {
    this.toDisplay.next(notification);
  }
}
